import React from "react";
import { Link } from "react-router-dom";

const TableRequestPrompt = ({ eventId, prompt, action }) => (
  <div className="table-request-prompt">
    <span className="table-request-prompt__text">{prompt}</span>
    <Link
      to={`/events/${eventId}/request-table`}
      className="table-request-prompt__link"
    >
      {action}
    </Link>
  </div>
);

export default TableRequestPrompt;
